import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-[#23242A] text-white app-header custom",
  id: "content_screen"
}
const _hoisted_2 = { class: "custom-full custom-left" }
const _hoisted_3 = { class: "bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]" }
const _hoisted_4 = { class: "flex justify-between mb-5 h-[40px]" }
const _hoisted_5 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component custom-right')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass('px-3 pt-3 pb-28 flex content-main ' + (_ctx.action.component ? ' half-it gap-5' : 'gap-5'))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Nav),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-[24px] font-semibold text-white" }, "Promotions", -1)),
            (!_ctx.action.component)
              ? (_openBlock(), _createBlock(_component_mdicon, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUpdate({ component: 'Add', data: {}}))),
                  size: "32",
                  name: "plus",
                  class: "text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_List, {
            selectedCallback: _ctx.selectedItem,
            clearComponent: _ctx.clearComponent,
            iscomponentactive: _ctx.action.component ? true : false
          }, null, 8, ["selectedCallback", "clearComponent", "iscomponentactive"])
        ])
      ]),
      (_ctx.action.component)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
              item: _ctx.action.data,
              clearComponent: _ctx.clearComponent
            }, null, 8, ["item", "clearComponent"]))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}